import { render } from "./LegacyCreateOrderView.vue?vue&type=template&id=63891ebd"
import script from "./LegacyCreateOrderView.vue?vue&type=script&lang=js"
export * from "./LegacyCreateOrderView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__